import { useUser } from '@/lib/auth';

export function useCanCreateClassroom(): boolean {
  const { user } = useUser();
  if (!user) return false;
  return user.type?.toLowerCase() !== 'student';
}
